import { inject, Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { SettingsService } from '../bootstrap';

@Injectable()
export class SettingsInterceptor implements HttpInterceptor {
  private readonly _settings = inject(SettingsService);

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(
      request.clone({
        headers: request.headers.append(
          'Accept-Language',
          this._settings.options.language
        ),
      })
    );
  }
}
